import { z } from '@/utils/zod'

export const clientAppHeaderName = 'x-client-app'

export const ClientAppTypeSchema = z.enum(['admin', 'connect', 'embeddable', 'root'])

export type ClientAppType = z.infer<typeof ClientAppTypeSchema>

export const ExtendedClientAppTypeSchema = z.enum([
    'admin',
    'connect-web',
    'connect-ios',
    'connect-android',
    'portal-web',
    'portal-ios',
    'portal-android',
    'embeddable',
    'root',
])

export type ExtendedClientAppType = z.infer<typeof ExtendedClientAppTypeSchema>

export const isConnectClientApp = (clientApp: ExtendedClientAppType | null | undefined) =>
    clientApp === 'connect-web' || clientApp === 'connect-ios' || clientApp === 'connect-android'

const extendedClientAppTypeLabelKeys = {
    admin: 'entities.common.clientAppType.admin',
    'connect-web': 'entities.common.clientAppType.connect-web',
    'connect-ios': 'entities.common.clientAppType.connect-ios',
    'connect-android': 'entities.common.clientAppType.connect-android',
    'portal-web': 'entities.common.clientAppType.portal-web',
    'portal-ios': 'entities.common.clientAppType.portal-ios',
    'portal-android': 'entities.common.clientAppType.portal-android',
    embeddable: 'entities.common.clientAppType.embeddable',
    root: 'entities.common.clientAppType.root',
} satisfies Record<ExtendedClientAppType, `entities.common.clientAppType.${ExtendedClientAppType}`>

export const getExtendedClientAppTypeLabelKey = (clientApp: ExtendedClientAppType) =>
    extendedClientAppTypeLabelKeys[clientApp]
